module.exports = __webpack_public_path__ + "static/media/RoundedCornerCollins.61fa3e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/RoundedCornerCollins.png
// module id = 43
// module chunks = 0